import 'zone.js'; // Included with Angular CLI.
import { Buffer } from 'buffer';
import process from 'process';

(globalThis as any).global = globalThis;
(globalThis as any).Buffer = (globalThis as any).Buffer || Buffer;
(globalThis as any).process = (globalThis as any).process || process;

if (typeof window !== 'undefined') {
  (window as any).Buffer = (window as any).Buffer || Buffer;
}
